/**
 * aaa-leather-guide
 * ---------------------------------------------------------------------------
 * Companion island for blocks/aaa-leather-guide.liquid.
 *
 * One job: make in-page anchor links inside the dialog work. A native
 * <dialog> with scroll-lock traps fragment navigation - the hash changes
 * but the page behind can't scroll, so the link appears dead. We close
 * the dialog first, then scroll to the target ourselves.
 *
 * Dependency-free island (F.9).
 */
(function () {
  if (customElements.get('aaa-leather-guide')) return;

  class AaaLeatherGuide extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.addEventListener('click', (e) => {
        var link = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
        if (!link) return;
        var target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        e.preventDefault();

        // Always close, and prefer the dialog-component's own method so its
        // scroll-lock is released properly. (The native `open` property is
        // not a reliable guard while Horizon's open/close animation runs.)
        var dc = this.querySelector('dialog-component');
        var dialog = this.querySelector('dialog');
        try {
          if (dc && typeof dc.closeDialog === 'function') {
            dc.closeDialog();
          } else if (dialog) {
            dialog.close();
          }
        } catch (err) {
          if (dialog) dialog.close();
        }

        // The scroll-lock release is tied to the close animation, so an
        // immediate scroll gets swallowed. Wait for it, then scroll.
        setTimeout(function () {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 450);
      });
    }
  }

  customElements.define('aaa-leather-guide', AaaLeatherGuide);
})();
